import React from "react";
import styles from "./FileItem.module.scss";
import { AiFillFileUnknown } from "react-icons/ai";

function FileItem({ title, link }) {
  return (
    <a href={link || "#"} className={styles.file}>
      <AiFillFileUnknown className={styles.icon} />
      <div className={styles.title}>{title || "بدون عنوان"}</div>
    </a>
  );
}

export default FileItem;
